"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _useMediaQuery = _interopRequireDefault(require("@material-ui/core/useMediaQuery"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var _default = function _default(Component) {
  return function (_ref) {
    var data = _ref.data,
        _ref$visibleSlides = _ref.visibleSlides,
        visibleSlides = _ref$visibleSlides === void 0 ? {} : _ref$visibleSlides,
        rest = _objectWithoutProperties(_ref, ["data", "visibleSlides"]);

    if (!Array.isArray(data) || !data.length) return null;
    var _visibleSlides$mobile = visibleSlides.mobile,
        mobile = _visibleSlides$mobile === void 0 ? 2 : _visibleSlides$mobile,
        _visibleSlides$deskto = visibleSlides.desktop,
        desktop = _visibleSlides$deskto === void 0 ? 3 : _visibleSlides$deskto;
    var isBreakpoint = (0, _useMediaQuery["default"])('(max-width:600px)');
    var len = data.length;
    var numOfSlides = Math.min(isBreakpoint ? mobile : desktop, len);
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({
      data: data,
      visibleSlides: numOfSlides,
      dragEnabled: len > numOfSlides,
      totalSlides: len
    }, rest));
  };
};

exports["default"] = _default;